// Generated from Contest's `required_filter_groups` — do not edit.

import type {FilterDefinitionMapping} from '../../boot/hooks/useApi'
import type {Iri} from '../Api'

export type ContestCollectionFilterGroups
  = | {
    readonly spot: Iri | Iri[]
  }

export const contestCollectionFilterMapping: FilterDefinitionMapping<ContestCollectionFilterGroups> = {
  spot: 'spot',
}

export type ContestCollectionSort = 'name' | 'startAt'
